import { useFormContext } from 'react-hook-form';

import { FlexItem } from 'shared_DEPRECATED/components/Flex';
import Spacer from 'shared_DEPRECATED/components/Spacer/Spacer';

import { CoachingToolsCardEditButtons } from 'features/sessions/components';
import { SessionsFormCoachingToolsSelector } from 'features/sessions/components/Form/CoachingTools';
import { CoachingTool } from 'features/sessions/config/types';

import { NextSessionFormMiroBoardLinkView } from './MiroBoardLinkField/Link/';

type NextSessionCoachingToolsCardEditProps = {
  formKey: string;
  onDelete: () => void;
  canBeDeleted: boolean;
  coachingTool: CoachingTool;
};

export const NextSessionCoachingToolsCardEdit = ({
  formKey,
  onDelete,
  canBeDeleted = false,
  coachingTool,
}: NextSessionCoachingToolsCardEditProps) => {
  const { setValue } = useFormContext();

  return (
    <>
      <FlexItem alignSelf="stretch">
        <SessionsFormCoachingToolsSelector
          onSelect={(coachingTool) => {
            setValue(`${formKey}.tool`, coachingTool, { shouldDirty: true });
          }}
          selected={coachingTool.tool.value}
        />
        {coachingTool.link && (
          <NextSessionFormMiroBoardLinkView text={coachingTool.link} />
        )}
      </FlexItem>
      <Spacer size="md" />
      <CoachingToolsCardEditButtons
        canBeDeleted={canBeDeleted}
        disabled={!coachingTool.tool.value}
        onDelete={onDelete}
        onSave={() => setValue(`${formKey}.editMode`, false)}
      />
    </>
  );
};
